<fieldset ngModelGroup="topWOSection">
  <div class="grayBG row" style="padding-bottom: 16px;">
    <div class="col-6 border-thing">
      <div class="row">
        <div class="col-12">
          <span class="bold">Quote Created: </span>
          {{workOrder.createdDate | date:'shortDate'}}
        </div>
        <div class="col-12">
          <span class="bold">
            Status:
          </span>
          {{workOrder.completionStatus}}
        </div>
        <div class="col-12">
          <span class="bold">Quote #:</span>
          {{estimateDisplayValue}}
        </div>
        @if (!isNotEditableOrExternal() && allowNewCustomer()) {
          <div class="col-2">
            <span class="bold">Customer: </span>
          </div>
        }
        @if (!isNotEditableOrExternal() && allowNewCustomer()) {
          <div class="col-8">
            <app-customer-dropdown
              [disabled]="isNotEditableOrExternal() || !allowNewCustomer()"
              [existingSelectionId]="workOrder.customer?.id"
              [required]="true"
              (customerSelected)="setCustomer($event)"
            ></app-customer-dropdown>
          </div>
        }
        @if (!workOrder.customer?.id) {
          <div class="col-2">
            <p-button
              type="button"
              severity="primary"
              [disabled]="isNotEditableOrExternal() || workOrder.customer?.id"
              (click)="addNewCustomer()">Add New
            </p-button>
          </div>
        }
        <!-- You either see the customer dropdown or a link to the customer page-->
        @if (isNotEditableOrExternal() || !allowNewCustomer()) {
          <div class="col-10">
            <span class="bold">Customer: </span>
            <a (click)="goToCustomer()" class="regular-link">{{workOrder.customer.fullName}}</a>
          </div>
        }
        @if (workOrder.customer?.id) {
          <div class="col-12">
            <span class="bold">Customer Phone: </span> {{workOrder.customer.primaryPhone | phoneNumber}}
          </div>
        }
        @if (workOrder.customer?.id) {
          <div class="col-12">
            <span class="bold">Customer Email: </span> {{customCustomerService.getPrimaryContact(workOrder.customer).emailAddress.email}}
          </div>
        }
        <div class="p-col">
          <span class="bold">Worksite Address: </span>
          @if (workOrder.address) {
            <span>
              @if (!editWorksiteAddress && workOrder.address.street) {
                <span>
                  {{workOrder.address.street}}, {{workOrder.address.city}} {{workOrder.address.state?.abbreviation}}, {{workOrder.address.zip}}
                  <i class="fa fa-map-marked-alt regular-link" (click)="workOrderHelperService.openMap(workOrder)"></i>
                </span>
              }
              &nbsp;
              @if (isEditable && editWorksiteAddress) {
                <span class="link" (click)="editWorksiteAddressOff()">[Done Editing]</span>
              }
              @if (isEditable && !editWorksiteAddress) {
                <span class="link" (click)="editWorksiteAddressOn()">[Edit]</span>
              }
              @if (editWorksiteAddress && isEditable) {
                <div style="margin-left: 25px;">
                  <span>Address Same As Customer Address</span> &nbsp;
                  @if (workOrder) {
                    <p-checkbox binary="true"
                      name="addressSameAsCustomer"
                      [(ngModel)]="workOrder.addressSameAsCustomer"
                      [disabled]="!isEditable || !workOrder.customer"
                      (onChange)="addressSameAsCustomerToggle()"
                    ></p-checkbox>
                  }
                  
                    <div style="max-width: 500px;">
                      <div>
                        <span>Address</span>
                        @if (workOrder && workOrder.address) {
                          <input
                            pInputText
                            required
                            name="street"
                            [(ngModel)]="workOrder.address.street"
                            [disabled]="!isEditable"
                            fluid
                            />
                        }
                      </div>
                      <div>
                        <span>City</span>
                        @if (workOrder && workOrder.address) {
                          <input
                            pInputText                    
                            required
                            name="city"
                            [(ngModel)]="workOrder.address.city"
                            [disabled]="!isEditable"
                            fluid
                            />
                        }
                      </div>
                      <div>
                        <span>State</span>
                        @if (workOrder) {
                          <ng-select
                            class="custom"
                            required
                            [items]="states"
                            placeholder="Select a State"
                            name="state"
                            [selectOnTab]="true"
                            bindLabel="name"
                            [(ngModel)]="workOrder.address.state"
                            [disabled]="!isEditable"
                            >
                          </ng-select>
                        }
                      </div>
                      <div>
                        <span>Zip</span>
                        @if (workOrder && workOrder.address) {
                          <input
                            pInputText
                            required                           
                            name="zip"
                            [(ngModel)]="workOrder.address.zip"
                            (ngModelChange)="zipChanged()"
                            [disabled]="!isEditable"
                            maxLength="5"
                            fluid
                            />
                        }
                      </div>
                    </div>
                  
                </div>
              }
            </span>
          }
        </div>
      </div>
    </div>
    @if (isQuote) {
      <div class="col-6">
        <div class="col-12">
          <span class="bold">
            Services Requested:
          </span>
          {{quoteRequestItems}}
        </div>
        <div class="col-12 showLineBreaks">
          <span class="bold">Quote Request Description: </span>
          {{quoteRequestDescription}}
        </div>
        <div class="col-12">
          <span class="bold">Customer Provided Uploads: </span>
          <app-blob-manager [angularUpload]="true"
            [containerName]="'quote-request'"
            [parentRecordId]="isQuote ? asQuote().quoteRequest?.id : asWorkOrder().quoteWorkOrder.requestForQuoteId"
            [uploadLabel]="'Document/Photo'"
            [viewOnly]="true">
          </app-blob-manager>
        </div>
      </div>
    }
    @if (!isQuote) {
      <div class="col-6">
        @if (!isCustomer) {
          <div class="col-12">
            <span class="bold">Company Wide Notes: </span>
            <app-customer-comment-view-only [customer]="workOrder.customer"></app-customer-comment-view-only>
          </div>
        }
        @if (!isCustomer) {
          <div class="col-12 showLineBreaks">
            <span class="bold">Message to Crew: </span>
            {{workOrder.crewNote}} &nbsp; <span class="link" (click)="toggleCrewEdit()">[Edit]</span>
            @if (editCrewMessage) {
              <div>
                <textarea pInputTextarea name="crewMessage" [(ngModel)]="workOrder.crewNote" [rows]="5"  style="width: 95%;"></textarea>
              </div>
            }
          </div>
        }
        <div class="col-12 showLineBreaks">
          <span class="bold">Message to Customer: </span>
          {{workOrder.note}}
        </div>
        @for (neighborPermission of neighborPermissions; track neighborPermission) {
          <span>
            @if (!neighborPermission.deleted) {
              <div class="col-12 showLineBreaks">
                <span class="bold">Neighbor's Permission: </span>
                {{neighborPermission.firstName}} {{neighborPermission.lastName}} granted permission on
                {{neighborPermission.signedDate | date: 'shortDate'}}
                for RTE to access the property at {{neighborPermission.address}}
                for the following activities: {{neighborPermission.activitiesOnNeighborProperty}}
              </div>
            }
          </span>
        }
        @if (workOrder.quoteWorkOrder.neighborPermissionRequired) {
          <div>
            &nbsp;<a class="link" target="_blank" [routerLink]="['/customerQuotePage', workOrder.quoteId]">[Go To Quote]</a>
          </div>
        }
      </div>
    }
  </div>
</fieldset>

<!-- Add New Customer dialog -->
<!-- Only dialogs inside class scrollableDialog get the CSS for scrolling. Only use scrollableDialog if the dialog actually has enough content that
it needs to scroll because it looks weird otherwise. -->
@if (displayCustomerDialog) {
  <div class="scrollableDialog">
    <p-dialog header="Customer Info" [(visible)]="displayCustomerDialog" [modal]="true" [resizable]="false" [baseZIndex]="10000"
      [maximizable]="true" [style]="{'width': '800px'}" [focusOnShow]="false" (onHide)="closedCustomerDialog()" [closable]="false">
      <p-header style="float:right;">
        <a tabindex="0" role="button" (click)="closedCustomerDialog()" (keydown.enter)="closedCustomerDialog()" (mousedown)="closedCustomerDialog()">
          <span><i class="pi pi-times"></i></span>
        </a>
      </p-header>
      <app-customer-maintenance [customer]="workOrder.customer" [isDialog]="true" (timeToClose)="closedCustomerDialog($event)" [sendWelcomeEmailOnAdd]="false"></app-customer-maintenance>
    </p-dialog>
  </div>
}
